import React from "react";

// TikTok glyph (lucide-react has no TikTok icon)
export const TiktokIcon = ({ className = "", ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path d="M16.5 5.5a4.9 4.9 0 0 1-3.35-1.32 4.9 4.9 0 0 1-1.36-2.68h-3.2v12.9a2.6 2.6 0 1 1-1.85-2.49V8.6a5.75 5.75 0 1 0 5.05 5.7V8.9a8 8 0 0 0 4.71 1.52V7.2c-.01 0-.02 0-.03-.01Z" />
  </svg>
);
